import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forkJoin, fromEvent, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { QrveyService } from '../../../../../core/lists/_services/qrvey.service';
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-users-access-list',
  templateUrl: './users-access-list.component.html',
  styleUrls: ['./users-access-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersAccessListComponent implements OnInit, OnDestroy {
  dataSource = [];
  displayedColumns = ['id', 'name', 'action'];
  private subscriptions: Subscription[] = [];
  private appId = null;
  @ViewChild('search', { static: true }) searchInput: ElementRef;
  allResult = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UsersAccessListComponent>,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private layoutUtilsService: LayoutUtilsService,
    private qrveyService: QrveyService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    public subheaderService: SubheaderService,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.app_id) {
        this.appId = params.app_id;
        this.loadTeamMembersList();
      }
    });
  }

  ngOnInit() {
    fromEvent(this.searchInput.nativeElement, 'keyup')
      .pipe(
        distinctUntilChanged(),
        tap(() => {
          this.dataSource = this.allResult.filter((val) =>
            val.name.includes(this.searchInput.nativeElement.value.toLowerCase()),
          );
          this.cdr.detectChanges();
        }),
      )
      .subscribe();
    if (this.data.type === 'CONTACT') {
      this.displayedColumns = ['id', 'name', 'hasBiAccess', 'action'];
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  loadTeamMembersList() {
    this.loading = true;
    if (this.data?.type === 'USER') {
      forkJoin({
        users: this.qrveyService.getUsers(this.data.ids),
        blockUsers: this.qrveyService.getBlockUsers(this.appId),
      })
        .pipe(
          map((response) => {
            const users = response.users.data as Array<any>;
            const blockUsers = response?.blockUsers?.data?.users;

            const resFinal = users
              ?.filter((e) => e.isActive)
              .map((user) => {
                const userBlock = blockUsers?.find(
                  (u) => u.user_id === user.id && u.user_type === 'USER',
                );
                const name = '' + user.name;
                user.name = name.toLowerCase();
                user.status = true;
                if (userBlock) {
                  user.status = false;
                }
                return user;
              });
            return resFinal;
          }),
        )
        .subscribe((data) => {
          if (!data) {
            return;
          }
          this.allResult = data.sort((a, b) => a.status - b.status);
          this.dataSource = this.allResult;
          this.loading = false;
          this.cdr.detectChanges();
        });
      return;
    }
    forkJoin({
      contact: this.qrveyService.getContacts(this.data.ids, this.data.entityId),
      blockUsers: this.qrveyService.getBlockUsers(this.appId),
    })
      .pipe(
        map((response) => {
          const users = response.contact.data as Array<any>;
          const blockUsers = response?.blockUsers?.data?.users;

          const resFinal = users?.map((user) => {
            const userBlock = blockUsers?.find(
              (u) => u.user_id === user.id && u.user_type === 'CONTACT',
            );
            const name = '' + user.name;
            user.name = name.toLowerCase();
            user.status = true;
            if (userBlock) {
              user.status = false;
            }
            return user;
          });
          return resFinal;
        }),
      )
      .subscribe((data) => {
        if (!data) {
          return;
        }
        this.allResult = data.sort((a, b) => a.status - b.status);
        this.dataSource = this.allResult;
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  block(teamMember) {
    this.qrveyService.blockUsers(teamMember, this.appId, this.data.type).subscribe(() => {
      this.loadTeamMembersList();
    });
  }

  unblock(teamMember) {
    this.qrveyService.unblockUsers(teamMember, this.appId, this.data.type).subscribe(() => {
      this.loadTeamMembersList();
    });
  }
}
